export default (theme) => ({
  root: {
    paddingTop: 4,
    textAlign: "center",
  },
});
